// Motions panel — pending vs. granted/denied. The current matter shape
// doesn't carry a motions array directly; we surface
// matter.workspace.motions if present, otherwise show an empty state
// with a "Draft motion" CTA.

interface MotionShape {
  title: string;
  status?: "pending" | "granted" | "denied" | "filed";
  filedDate?: string;
}

interface Props {
  motions: MotionShape[] | undefined;
}

const STATUS_TONE: Record<string, { bg: string; fg: string }> = {
  pending: { bg: "var(--warn-50)", fg: "var(--warn-600)" },
  filed: { bg: "var(--bg-2)", fg: "var(--muted)" },
  granted: { bg: "var(--ok-50)", fg: "var(--ok-600)" },
  denied: { bg: "var(--red-50)", fg: "var(--red-600)" },
};

export function MotionsPanel({ motions }: Props) {
  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Motions</div>
        <div className="cc-card-sub">· {motions?.length ?? 0} on docket</div>
        <div className="actions">
          <button className="cc-link-btn">Draft motion</button>
        </div>
      </div>
      {!motions || motions.length === 0 ? (
        <div style={{ padding: "16px 18px", color: "var(--muted)", fontSize: 12.5 }}>
          No motions filed yet.
        </div>
      ) : (
        <div style={{ padding: "8px 18px 14px" }}>
          {motions.map((m, i) => {
            const tone = m.status ? STATUS_TONE[m.status] : undefined;
            return (
              <div
                key={i}
                style={{
                  padding: "8px 0",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  borderBottom: i === motions.length - 1 ? "none" : "1px solid var(--line-2)",
                }}
              >
                {tone && (
                  <span
                    style={{
                      fontSize: 9.5,
                      fontWeight: 700,
                      padding: "2px 6px",
                      borderRadius: 4,
                      background: tone.bg,
                      color: tone.fg,
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {m.status}
                  </span>
                )}
                <span style={{ fontSize: 12.5, fontWeight: 550 }}>{m.title}</span>
                {m.filedDate && (
                  <span
                    style={{
                      marginLeft: "auto",
                      fontVariantNumeric: "tabular-nums",
                      fontSize: 10.5,
                      color: "var(--muted)",
                    }}
                  >
                    {m.filedDate}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
